import { useState } from "react";
import QRCode from "qrcode";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { StickerQrCode } from "sticker_templates";

const getProductLocationIdentifier = (product) =>
  product?.product_main_locations?.find(
    ({ warehouse_id }) => warehouse_id === 2,
  )?.warehouse_position?.identifier;

const GenerateQrButton = ({ product, quantity }) => {
  const [is_generating, setGenerating] = useState(false);
  const product_location_identifier = getProductLocationIdentifier(product);

  const handleGenerateQr = async () => {
    try {
      setGenerating(true);
      const qr_code_base64 = await QRCode.toDataURL(product.sku);
      const blob = await pdf(
        <StickerQrCode
          data={[
            {
              sku: product.sku,
              name: product.name,
              quantity,
              product_location_identifier,
              qr_code_base64,
            },
          ]}
        />,
      ).toBlob();
      saveAs(blob, `${product.sku}-qr.pdf`);
    } catch (error) {
      console.log(error);
    } finally {
      setGenerating(false);
    }
  };

  if (!product_location_identifier) {
    return (
      <span className="text-underline m-t-5 d-block">
        Brak identyfikatora lokalizacji na magazynie wysyłkowym
      </span>
    );
  }

  return (
    <div className="m-t-5">
      <button
        disabled={is_generating}
        type="button"
        className="btn btn-sm btn-danger"
        onClick={handleGenerateQr}
        style={{padding: '0 4px'}}
      >
        <span style={{fontSize: 12}}>
          {is_generating
            ? "Proszę czekać..."
            : `QR (${Number(quantity).toFixed(0)}x)`}
        </span>
      </button>
    </div>
  );
};

export default GenerateQrButton;
